import "./ComputingChoose.css";
import img from "../computingassets/computingchoose.png";

export default function ComputingChoose() {
  return (
    <div id="computing-choose" className="outsourcemainclass">
      <div className="left">
        <div className="offer-item content content1">
          <h2>Key Benefits of DevOps Automated Testing</h2>
          <p>
            BastionEx delivers expert containerization services with proven
            DevOps and cloud experience. We provide secure, scalable, and
            compliant solutions, integrating containers into CI/CD pipelines.
            Our customized strategies ensure consistent deployments, optimized
            performance, simplified operations, and flexibility across
            on-premises, cloud, and hybrid environments, enabling faster
            application delivery and reliable system management.
          </p>
          <ul>
            <li>
              Assessment &amp; Planning
              <p>Analyze your development workflow, tools, and objectives</p>
            </li>
            <li>
              Assessment &amp; Planning
              <p>Analyze your development workflow, tools, and objectives</p>
            </li>
            <li>
              Assessment &amp; Planning
              <p>Analyze your development workflow, tools, and objectives</p>
            </li>
            <li>
              Assessment &amp; Planning
              <p>Analyze your development workflow, tools, and objectives</p>
            </li>
          </ul>
        </div>
      </div>
      <div className="right">
        <img src={img} alt="error" />
      </div>
    </div>
  );
}
